import { Coaching } from '@kinomap-dev/ng-ui-lib';

export class CoachingState {
  coachings: Coaching[] = [];
  isLoadingCoachings: boolean = false;
  areCoachingsComplete: boolean = false;
}
